import type React from "react";
import {
  Box,
  Typography,
  Modal,
  Stack,
  Button,
  IconButton,
} from "@mui/material";
import { useState } from "react";
import CustomTextField from "../../../../components/ui/Textfield";
import { Close } from "@mui/icons-material";

interface AddTestimonialModalProps {
  open: boolean;
  onClose: () => void;
  onSave: (data: {
    author_name: string;
    author_description: string;
    content: string;
    rating: number;
  }) => void;
}

const modalStyle = {
  position: "absolute" as const,
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 420,
  bgcolor: "background.paper",
  borderRadius: 3,
  boxShadow: 24,
  p: 4,
};

const AddTestimonialModal: React.FC<AddTestimonialModalProps> = ({
  open,
  onClose,
  onSave,
}) => {
  const [author, setAuthor] = useState("");
  const [text, setText] = useState("");
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    if (!author || !text) return;

    try {
      setSaving(true);
      await onSave({
        author_name: author,
        author_description: "",
        content: text,
        rating: 5,
      });
      onClose();
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalStyle}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 3,
          }}
        >
          <Typography variant="h6">Add Testimonial</Typography>
          <IconButton onClick={onClose}>
            {" "}
            <Close />
          </IconButton>
        </Box>

        <Stack spacing={3}>
          <CustomTextField
            label="Author"
            fullWidth
            value={author}
            onChange={(e) => setAuthor(e.target.value)}
          />

          <CustomTextField
            label="Testimonial"
            multiline
            rows={4}
            fullWidth
            value={text}
            onChange={(e) => setText(e.target.value)}
          />

          <Button
            variant="contained"
            onClick={handleSave}
            disabled={saving || !author || !text}
          >
            {saving ? "Saving..." : "Save"}
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default AddTestimonialModal;
